export const initState = {
  version: 0,
  synced: true,
};

export const types = {
  GET_VERSION: "GET_VERSION",
  PUT_VERSION: "PUT_VERSION",
};
